import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderBy' })
export class OrderByPipe implements PipeTransform {
  transform(array: any[], sortBy: string, order: string): any[] {
    if (!array || !Array.isArray(array)) {
      return array;
    }
    const sortOrder = order === 'desc' ? -1 : 1;
    
    // Create a shallow copy before sorting because sort() mutates the array
    return [...array].sort((a, b) => {
      const aVal = a[sortBy];
      const bVal = b[sortBy];
      if (aVal < bVal) return -1 * sortOrder;
      if (aVal > bVal) return 1 * sortOrder;
      return 0;
    });
  }
}
